import { createApp } from 'vue'
import App from './App.vue'
import './assets/styles/tailwind.css'
import router from './router'
import momentPlugin from "@/plugins/momentPlugin"
import axios from "axios";

const app = createApp(App)

app.use(router)
app.use(momentPlugin)

const API_KEY = '4e6c2d7b22c64028a6ec0e2d9b738fb9'         //API key

//Sending the API key as header by using axios interceptor
axios.interceptors.request.use(
    config => {
        config.headers['Authorization'] = API_KEY // You can use any header name like 'Authorization'
        config.withCredentials = true
        return config
    },
    error => {
        return Promise.reject(error)
    }
)

app.config.globalProperties.$axios = axios

app.mount('#app')
